// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"212":"e71a3038","703":"524c519c","940":"d4a94251"}[chunkId] + ".chunk.css";
};